import { dashboardBreadcrumbs } from "../features/Dashboard/dashboard-breadcrumbs";
import { ConnectedApps } from "../features/ConnectedApps";
import { PageLayout } from "../shared/layouts/PageLayout";

const breadcrumbs = {
  current: dashboardBreadcrumbs.integrations,
  previous: [dashboardBreadcrumbs.accountSettings],
};

export function ConnectedAppsPage() {
  return (
    <PageLayout breadcrumbs={breadcrumbs}>
      <ConnectedApps />
    </PageLayout>
  );
}
